import { render, staticRenderFns } from "./GInputPhoneNumber.vue?vue&type=template&id=8e9cfc22&"
import script from "./GInputPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./GInputPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./GInputPhoneNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports